import { Input, InputImperativeActions } from '@wix/design-system'
import classNames from 'classnames'
import React, { ComponentProps, forwardRef } from 'react'

import s from './WixMobileInput.scss'

type WixMobileInputProps = ComponentProps<typeof Input>

export const WixMobileInput = forwardRef<InputImperativeActions, WixMobileInputProps>(
  ({ className, size = 'medium', ...props }, ref) => (
    <Input {...props} ref={ref} size={size} className={classNames(s.input, className)} />
  ),
)

WixMobileInput.displayName = 'WixMobileInput'
